import { ImageProps } from "@/ui";
import AppImage from "./AppImage";

export default function Logo({ imgProps }: { imgProps?: ImageProps }) {
  return <AppImage name="logo.svg" options={{ imgProps }} />;
}
